<editor [init]="tinyInit" [formControl]="fc()" />
